import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { observable, action, computed } from 'mobx';
import { task } from 'mobx-task';
import { truncate } from 'lodash';
import { Model } from 'libx';
import Document from '../../Document';
import { populateValidationContextFromError, extractMessageFromError } from '../../../utils/errorUtil';
import { validationContext } from 'validx';
var NewDocumentState = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = task.resolved, _class = /*#__PURE__*/function (_Model) {
  function NewDocumentState(attrs, opts) {
    var _this;
    _classCallCheck(this, NewDocumentState);
    _this = _callSuper(this, NewDocumentState, arguments);
    // Used by views to determine what component to render.
    _this.viewType = 'NewDocument';
    // Used by the sidebar to render a title
    _this.viewTitle = 'Upload New Document';
    // Used by the sidebar to render tabs
    // viewTabs = ['Info', 'Files', 'Access', 'History']
    // Used by the sidebar root to determine what tab to render (if using tabs)
    // @observable viewTab = 'Info'
    _initializerDefineProperty(_this, "tags", _descriptor, _this);
    _initializerDefineProperty(_this, "files", _descriptor2, _this);
    _initializerDefineProperty(_this, "title", _descriptor3, _this);
    _initializerDefineProperty(_this, "description", _descriptor4, _this);
    _initializerDefineProperty(_this, "confirmationGranted", _descriptor5, _this);
    _initializerDefineProperty(_this, "documentType", _descriptor6, _this);
    _this.validation = validationContext(_this, Document.validationRules);
    _this.save = _this.save.bind(_this);
    _this.close = opts.close;
    _this.confirmationRequired = opts.rootStore.sessionStore.workspace.features.documentConfig.documentUploadConfirmation.enabled;
    _this.confirmationText = opts.rootStore.sessionStore.workspace.features.documentConfig.documentUploadConfirmation.text;
    if (_this.files.length > 0) {
      _this.title = _this.files[0].name;
    }
    return _this;
  }

  // Used by the sidebar to render a subtitle
  _inherits(NewDocumentState, _Model);
  return _createClass(NewDocumentState, [{
    key: "viewSubtitle",
    get: function get() {
      if (this.files.length > 0) {
        return truncate(this.files[0].name, {
          length: 50
        });
      }
      return '';
    }
  }, {
    key: "canChangeDocumentType",
    get: function get() {
      return true;
    }
  }, {
    key: "setTags",
    value: function setTags(tags) {
      this.tags = tags;
    }
  }, {
    key: "confirm",
    value: function confirm(value) {
      this.confirmationGranted = value;
    }
  }, {
    key: "setDocumentType",
    value: function setDocumentType(documentType) {
      this.documentType = documentType;
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid, _this$documentType, doc;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.confirmationRequired && !this.confirmationGranted)) {
                _context.next = 3;
                break;
              }
              this.validation.addErrors({
                confirmationGranted: ['Please acknowledge the above.']
              });
              return _context.abrupt("return");
            case 3:
              valid = this.validation.reset().validate().isValid;
              if (valid) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              _context.next = 9;
              return this.rootStore.documentStore.createDocument({
                title: this.title,
                description: this.description,
                tags: this.tags.slice(),
                access: this.access,
                workspace_id: this.workspaceId,
                created_for_user_id: this.createdForUserId,
                document_type_id: (_this$documentType = this.documentType) === null || _this$documentType === void 0 ? void 0 : _this$documentType.id
              });
            case 9:
              doc = _context.sent;
              this.close();
              _context.next = 13;
              return this.rootStore.documentVersionStore.createVersion({
                message: 'Initial Version',
                document_id: doc.id,
                action: {
                  type: 'ReplaceContents',
                  files: this.files
                }
              });
            case 13:
              _context.next = 20;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);
              populateValidationContextFromError(this.validation, _context.t0);
              this.rootStore.flashMessageStore.create({
                type: 'error',
                message: extractMessageFromError(_context.t0)
              });
              throw _context.t0;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 15]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "tags", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "files", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "title", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "confirmationGranted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "documentType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "viewSubtitle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "viewSubtitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTags", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "setTags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDocumentType", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "setDocumentType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _class);
export { NewDocumentState as default };
//# sourceMappingURL=NewDocumentState.js.map
